import { GetMissingFieldsLevelParameter } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_PAYER } from "..";
import { useQueryCustomerEntity } from "../../../query/onboarding/queries/useQueryCustomerEntity";
import { queriesOnboarding } from "@query";
import { useWSAnalytics } from "../../../utils/WSAnalytics";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";

const payerOnboardingModules: OnboardingModule[] = [
  {
    type: "create_account",
    options: {
      accountTypes: ["Business"],
      verificationLevel: GetMissingFieldsLevelParameter.BANKING
    }
  },
  { type: "additional_information" },
  {
    type: "payroll_funding_method"
  },
  {
    type: "payroll_settings"
  },
  {
    type: "business_profile"
  }
];

export const RoutePayerOnboarding: React.FC = () => {
  const history = useHistory();
  const { track } = useWSAnalytics();
  const queryCustomerEntity = useQueryCustomerEntity();
  const queryVerifications = queriesOnboarding.getOnboardingStatus.useQuery(
    undefined,
    { select: status => status.verifications }
  );

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_PAYER}
      modules={payerOnboardingModules}
      onSuccess={() => {
        history.push("/member/dashboard");

        track.other("Onboarding Completed", {
          onboardingType: "payer",
          entityType: queryCustomerEntity.data?.type,
          entityCountry: queryCustomerEntity.data?.country,
          taxVerificationStatus: queryVerifications.data?.tax,
          bankingVerificationStatus: queryVerifications.data?.banking,
          enhancedVerificationStatus: queryVerifications.data?.enhanced
        });
      }}
    />
  );
};
